module.exports = __webpack_public_path__ + "9b2805e5161fbe99927496ae472918ad.png";